import { render } from "./archive-list-item.vue?vue&type=template&id=516f0ef7&scoped=true"
import script from "./archive-list-item.vue?vue&type=script&lang=js"
export * from "./archive-list-item.vue?vue&type=script&lang=js"

import "./archive-list-item.vue?vue&type=style&index=0&id=516f0ef7&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516f0ef7"],['__file',"src/components/notepad/archives/archive-list-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "516f0ef7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('516f0ef7', __exports__)) {
    api.reload('516f0ef7', __exports__)
  }
  
  module.hot.accept("./archive-list-item.vue?vue&type=template&id=516f0ef7&scoped=true", () => {
    api.rerender('516f0ef7', render)
  })

}


export default __exports__